var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigateLast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.310078 0.709778C-0.0799219 1.09978 -0.0799219 1.72978 0.310078 2.11978L4.19008 5.99978L0.310078 9.87978C-0.0799219 10.2698 -0.0799219 10.8998 0.310078 11.2898C0.700078 11.6798 1.33008 11.6798 1.72008 11.2898L6.31008 6.69978C6.70008 6.30978 6.70008 5.67978 6.31008 5.28978L1.72008 0.699778C1.34008 0.319778 0.700078 0.319778 0.310078 0.709778Z",
    fill: "#707683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31008 0.709778C7.92008 1.09978 7.92008 1.72978 8.31008 2.11978L12.1901 5.99978L8.31008 9.87978C7.92008 10.2698 7.92008 10.8998 8.31008 11.2898C8.70008 11.6798 9.33008 11.6798 9.72008 11.2898L14.3101 6.69978C14.7001 6.30978 14.7001 5.67978 14.3101 5.28978L9.72008 0.699778C9.34008 0.319778 8.70008 0.319778 8.31008 0.709778Z",
    fill: "#707683"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateLast);
export default __webpack_public_path__ + "static/media/navigate-last.6d1ad6eb6b82cf83f67fb21a7f8c8347.svg";
export { ForwardRef as ReactComponent };